import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_TOTAL_SIN_ANALISIS } from '../../../../config/tables'

export default function TotalMercaderiaSinAnalisisView () {
  return <MuiTable id={TABLA_TOTAL_SIN_ANALISIS} />
}
